module.exports = __webpack_public_path__ + "img/ch.e93182ec.png";